/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../http/http';
import { success, error } from '../../../services/alert-message';

const urlApi = 'lgpd/api/v1/processos';

/**
* Buscando informacoes
* @param {*} param0
*/
export async function informacoesList({ commit }, obj) {
  Loading.show();
  return (await http.get(`lgpd/api/v1/processos/${obj.processo.id}/regulamentos/${obj.regulamento.id}/contextos/${obj.contexto.id}/informacoes`, obj)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}


/**
* Salvando informacoes
* @param {*} param0
*/
export async function informacoesSave({ commit }, obj) {
  Loading.show();
  return (await http.post(`lgpd/api/v1/processos/${obj.processo.id}/regulamentos/${obj.regulamento.id}/contextos/${obj.contexto.id}/informacoes`, obj)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
